import './utils/polyfill';
import 'react-app-polyfill/ie11';
import BaseEntryPoint from './BaseEntryPoint';

window.EntryPoint = new BaseEntryPoint();
